/* ============================================================================
   LAH — BARREIRA DE COMPRA: MUITOS OCULOS SEM NENHUMA LENTE DE GRAU
   Tema: Setembro/Outubro (Layout 4.0)

   ============================================================================
   A REGRA
   ============================================================================
   Pedido com 3 ou mais oculos — de grau E de sol, somados — so e aceito se
   tiver PELO MENOS UMA lente de grau aplicada.

     1 grau + lente de grau, 2 solares sem grau ........ PASSA
     3 armacoes de grau, nenhuma lente .................. TRAVA
     3 solares com lente solar sem grau ................. TRAVA
     2 oculos quaisquer, sem grau ....................... PASSA (abaixo do minimo)

   Quem compra varios oculos sem grau nenhum tende a devolver: o padrao e
   comprar para provar em casa e ficar com um. Havendo lente de grau, ha um
   pedido real sob medida — e os demais oculos acompanham.

   ============================================================================
   SEM SAIDA PELO WHATSAPP — de proposito
   ============================================================================
   A versao anterior convidava a "finalizar pelo WhatsApp". Isso transferia a
   venda para outro canal em vez de recusa-la — e a politica e nao aceitar
   esses pedidos.

   Agora o aviso explica a regra e diz as duas unicas formas de seguir:
   incluir lentes de grau em um dos oculos, ou reduzir a quantidade. Nenhum
   link para outro canal. O tom e de politica da loja, nao de suspeita: o
   cliente comum que caiu aqui sem querer entende o que fazer.

   ============================================================================
   COMO RECONHECEMOS LENTE DE GRAU
   ============================================================================
   Todas as lentes tem o mesmo tipo de produto ("Lentes para oculos"), entao o
   tipo nao distingue. Usamos os TITULOS das lentes que so existem com grau:

     grau ......... Normal, Fina, Super Fina, Base, Amplo, Dinamico,
                    Multifocal Normal / Fina / Super Fina
     solar c/ grau  Solar Normal / Fina / Super Fina, Solar Base / Amplo /
                    Dinamico, Solar Classica com Grau

   Sem grau — e portanto fora da conta: Sem Grau Filtro Luz Azul, Solar
   Classica, Polarizada, Verde G15, Marrom, Cinza, e os tratamentos.

   SE UMA LENTE NOVA DE GRAU FOR CRIADA, o titulo dela precisa entrar na lista
   GRAU abaixo. Sem isso, pedidos com ela seriam travados indevidamente.

   ============================================================================
   O LIMITE HONESTO
   ============================================================================
   A barreira vive no navegador: trava o botao do carrinho, a gaveta e o
   pagamento expresso. Quem digitar /checkout direto passa. Bloqueio
   incontornavel so com Shopify Function de validacao de carrinho (app).

   So consulta o carrinho quando ha um botao de finalizar na tela.
   ============================================================================ */

(function () {
    'use strict';

    var CFG = window.LAH_BARREIRA || {};
    if (!CFG.ativa) return;

    var MIN = parseInt(CFG.min, 10) || 3;
    var DEBUG = window.location.search.indexOf('lahdebug') !== -1;

    var TIPOS_OCULOS = ['oculos', 'oculos de sol'];

    /* Lentes que so existem com grau — ver a nota no topo. */
    var GRAU = [
        'normal', 'fina', 'super fina',
        'base', 'amplo', 'dinamico',
        'multifocal normal', 'multifocal fina', 'multifocal super fina',
        'solar normal', 'solar fina', 'solar super fina',
        'solar base', 'solar amplo', 'solar dinamico',
        'solar classica com grau'
    ];

    var BOTOES = [
        'button[name="checkout"]',
        'input[name="checkout"]',
        'a[href="/checkout"]',
        'a[href^="/checkout?"]'
    ].join(',');

    var EXPRESSO = [
        '.shopify-payment-button',
        'shopify-accelerated-checkout-cart',
        '.additional-checkout-buttons',
        '[data-shopify="dynamic-checkout-cart"]'
    ].join(',');

    var bloqueado = false;
    var ultimoTrack = null;

    function log() {
        if (!DEBUG) return;
        try { console.log.apply(console, ['[lah-barreira]'].concat([].slice.call(arguments))); } catch (e) {}
    }

    function track(ev, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: ev }, dados || {}));
        } catch (e) {}
    }

    function normalize(t) {
        return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function esc(t) {
        return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* {minimo} e {maximo} no texto do aviso viram numeros. */
    function preencher(t) {
        return esc(t || '')
            .replace(/\{minimo\}/g, MIN)
            .replace(/\{maximo\}/g, MIN - 1);
    }

    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-barreira-off{opacity:.45!important;pointer-events:none!important;cursor:not-allowed!important;}' +
        '.lah-barreira-oculto{display:none!important;}' +
        '.lah-barreira{background:#FFF6E5;border:1px solid #F0D9A8;color:#5C4312;border-radius:12px;' +
        'padding:14px 16px;margin:0 0 12px;line-height:1.45;text-align:left;}' +
        '.lah-barreira strong{display:block;margin-bottom:4px;}';
    document.head.appendChild(estilo);

    /* ---------------------------------------------------------------------
       REGRA — ver a tabela no topo
       --------------------------------------------------------------------- */
    function avaliar(cart) {
        var oculos = 0;
        var grau = 0;

        (cart.items || []).forEach(function (item) {
            var tipo = normalize(item.product_type);

            if (TIPOS_OCULOS.indexOf(tipo) !== -1) {
                oculos += item.quantity;
            } else if (tipo === 'lentes para oculos' &&
                       GRAU.indexOf(normalize(item.product_title)) !== -1) {
                grau += item.quantity;
            }
        });

        log('oculos', oculos, 'lentes de grau', grau, 'minimo', MIN);

        return { oculos: oculos, travar: oculos >= MIN && grau === 0 };
    }

    function aviso() {
        var el = document.createElement('div');
        el.className = 'lah-barreira text--small';
        el.setAttribute('data-lah-barreira', '');
        el.setAttribute('role', 'alert');
        el.innerHTML =
            '<strong>' + preencher(CFG.titulo || 'Pedidos com {minimo} ou mais óculos incluem lentes de grau') + '</strong>' +
            preencher(CFG.texto || 'Para seguir, adicione lentes de grau a pelo menos um dos óculos, ou mantenha até {maximo} no carrinho.');
        return el;
    }

    function aplicar(estado) {
        bloqueado = estado.travar;

        Array.prototype.forEach.call(document.querySelectorAll(BOTOES), function (b) {
            b.classList.toggle('lah-barreira-off', bloqueado);
            if (bloqueado) {
                b.setAttribute('aria-disabled', 'true');
                if ('disabled' in b) b.disabled = true;
            } else {
                b.removeAttribute('aria-disabled');
                if ('disabled' in b) b.disabled = false;
            }

            var pai = b.parentNode;
            var existente = pai && pai.querySelector(':scope > [data-lah-barreira]');

            if (bloqueado && pai && !existente) {
                pai.insertBefore(aviso(), b);
            } else if (!bloqueado && existente) {
                existente.remove();
            }
        });

        Array.prototype.forEach.call(document.querySelectorAll(EXPRESSO), function (e) {
            e.classList.toggle('lah-barreira-oculto', bloqueado);
        });

        /* Um evento por mudanca de estado, nao a cada redesenho do carrinho. */
        var chave = bloqueado ? 'travado-' + estado.oculos : 'livre';
        if (chave !== ultimoTrack) {
            ultimoTrack = chave;
            if (bloqueado) track('lah_barreira_travou', { oculos: estado.oculos, minimo: MIN });
        }
    }

    var consultando = false;
    var pendente = null;

    function verificar() {
        if (!document.querySelector(BOTOES) && !document.querySelector(EXPRESSO)) return;
        if (consultando) return;
        consultando = true;

        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { aplicar(avaliar(cart)); })
            .catch(function () { /* erro nunca trava a compra */ })
            .then(function () { consultando = false; });
    }

    function agendar() {
        clearTimeout(pendente);
        pendente = setTimeout(verificar, 250);
    }

    /* Rede de seguranca: mesmo se algo reabilitar o botao, o envio e barrado. */
    document.addEventListener('click', function (event) {
        if (!bloqueado) return;
        if (event.target.closest(BOTOES) || event.target.closest(EXPRESSO)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, true);

    document.addEventListener('submit', function (event) {
        if (!bloqueado) return;
        var sub = event.submitter;
        if (sub && sub.name === 'checkout') {
            event.preventDefault();
            event.stopPropagation();
        }
    }, true);

    ['cart:refresh', 'cart:change', 'cart:updated', 'cart-drawer:open'].forEach(function (ev) {
        document.addEventListener(ev, agendar);
    });

    if (window.MutationObserver) {
        new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', verificar);
    } else {
        verificar();
    }
})();
